export default __webpack_public_path__ + "static/media/partner-arcade-galaxy.e1c7cd8f.png";